import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import store from "../../../../../../store";
import workspace from "../../core/workspace";
import {LineHandlesModel} from "../models/LineHandlesModel";

export class HandlesController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.handles;
  }

  generateHandles() {
    const reduxState = store.getState();
    const selectedPartIds = reduxState.sqftResourceState.selectedPartIds
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (selectedPartIds.includes(shape.partId)) {
        this.addHandleToTheShape(shape);
      }
    }
  }

  addHandleToTheShape(shape) {
    const reduxState = store.getState();
    const selectedFeature = reduxState.sqftResourceState.selectedFeature
    const lines = shape.getLines();
    for (const lineIndex in lines) {
      if (+lineIndex === 2) {
        if (lines.hasOwnProperty(lineIndex)) {
          lines[lineIndex].setHandleId(selectedFeature.part.dbFeature.id);
          this.addResource(new LineHandlesModel(lines[lineIndex].id, selectedFeature.part.dbFeature.id));
        }
      }
    }
  }

  exportHandles() {
    return this.export()
  }
}

